import { Component, computed, input } from '@angular/core';

import {
  formatCellValue,
  processAddressValue
} from '@shared/components/table/table-cell/utils';

import { CellOverlayAction } from '../../actions-overlay/actions-overlay.component';
import { CellWithOverlayActions } from '../../table-cell.component';

@Component({
  selector: 'app-address-cell',
  standalone: true,
  templateUrl: './address-cell.component.html'
})
export class AddressCellComponent implements CellWithOverlayActions {
  availableCellActions: CellOverlayAction[] = ['copy'];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];
  valueAsString = (v: unknown) => formatCellValue(v, 'address');

  value = input<unknown | undefined>(undefined);

  protected processedValue = computed<string>(() => processAddressValue(this.value()));
}
